// extracted by mini-css-extract-plugin
module.exports = {"BLOCK":"TinyButton_BLOCK__2dt9q"};